/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import ContentLoader from "react-content-loader";
import {SkeletonSettings} from "../../../../../atoms/effects/skeletons/utils/SkeletonSettings";
import React from "react";

export const CartRowSkeletonMobile = (props) => (
    <ContentLoader
        width={"100%"}
        height={300}
        speed={SkeletonSettings.SPEED}
        backgroundColor={SkeletonSettings.BACKGROUND}
        foregroundColor={SkeletonSettings.FOREGROUND}
        style={{borderBottom: SkeletonSettings.BORDER}}
        {...props}>

        {/* Thumbnail image */}
        <rect x="12" y="16" width="80" height="80"/>

        {/* Product details */}
        <rect x="102" y="16" rx="3" ry="3" width="50%" height="10"/>
        <rect x="102" y="40" rx="3" ry="3" width="48%" height="10"/>
        <rect x="102" y="60" rx="3" ry="3" width="46%" height="10"/>

        {/* Remove from cart button */}
        <circle cx={`calc(100% - 23px)`} cy="23" r="14"/>

        {/* Packaging info */}
        <rect x="12" y="116" rx="3" ry="3" width="20%" height="10"/>
        <rect x="12" y="136" rx="3" ry="3" width="20%" height="10"/>

        {/* Weight price */}
        <rect x={`calc(12px + 33.33%)`} y="116" rx="3" ry="3" width="20%" height="10"/>
        <rect x={`calc(12px + 33.33%)`} y="136" rx="3" ry="3" width="20%" height="10"/>

        {/* Unit price */}
        <rect x={`calc(12px + 66.66%)`} y="116" rx="3" ry="3" width="20%" height="10"/>
        <rect x={`calc(12px + 66.66%)`} y="136" rx="3" ry="3" width="20%" height="10"/>

        {/* Stock Information */}
        <rect x="12" y="170" rx="3" ry="3" width="30%" height="10"/>

        {/* Quantity selector */}
        <rect x="30" y={`calc(90% - 28px)`} width="1%" height="3"/>
        <rect x={`calc(35px + 1%)`} y={`calc(90% - 48px)`} width="40" height="40"/>
        <rect x={`calc(80px + 1%)`} y={`calc(90% - 28px)`} width="1%" height="3"/>

        {/* Total price */}
        <rect x={`calc(12px + 66.66%)`} y={`calc(90% - 28px)`} rx="3" ry="3" width="20%" height="10"/>

    </ContentLoader>
);
